import outlineColumnIds from "./outlineColumnIds";

const DATE_FIELD_START = "startDate";
const DATE_FIELD_LATEST_START = "latestStartDate";
const DATE_FIELD_EARLIEST_END = "earliestEndDate";
const DATE_FIELD_END = "endDate";

const DATE_FIELDS = [DATE_FIELD_START, DATE_FIELD_LATEST_START, DATE_FIELD_EARLIEST_END, DATE_FIELD_END];

const DATE_FILED_TITLES = {
  [DATE_FIELD_START]: "Start",
  [DATE_FIELD_LATEST_START]: "Latest Start",
  [DATE_FIELD_EARLIEST_END]: "Earliest End",
  [DATE_FIELD_END]: "End"
};

const getDateFieldTitle = (field, startLabel, endLabel) => {
  let title = DATE_FILED_TITLES[field];
  if (startLabel) {
    title = title.replace("Start", startLabel);
  }
  if (endLabel) {
    title = title.replace("End", endLabel);
  }
  return title;
};

const DATE_CHANGE_FUNCTIONS = {
  [DATE_FIELD_START]: "onStartDateChange",
  [DATE_FIELD_LATEST_START]: "onLatestStartChange",
  [DATE_FIELD_EARLIEST_END]: "onEarliestEndChange",
  [DATE_FIELD_END]: "onEndDateChange"
};

const COLUMN_ID_TO_DATE_FIELD = {
  [outlineColumnIds.start]: DATE_FIELD_START,
  [outlineColumnIds.latestStart]: DATE_FIELD_LATEST_START,
  [outlineColumnIds.earliestEnd]: DATE_FIELD_EARLIEST_END,
  [outlineColumnIds.end]: DATE_FIELD_END
};

export {
  COLUMN_ID_TO_DATE_FIELD,
  DATE_CHANGE_FUNCTIONS,
  DATE_FIELD_EARLIEST_END,
  DATE_FIELD_END,
  DATE_FIELD_LATEST_START,
  DATE_FIELD_START,
  DATE_FIELDS,
  DATE_FILED_TITLES,
  getDateFieldTitle};
